import pagesJson from "@/data/pages.json";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/storage";
import axios from "axios";

// Get a Firestore instance
firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIRE_API_KEY,
  authDomain: process.env.VUE_APP_FIRE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIRE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIRE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIRE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIRE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIRE_ID,
});

export default {
  async fetchSession({ commit }, sessionId) {
    //  connecting page is shown by default at the start
    commit("SET_CONNECTION_STATUS", {
      type: "connecting",
      message: "Checking the session ID",
    });

    // fetch data from server
    axios
      .get(".netlify/functions/session/" + sessionId, {
        headers: {
          Authorization: process.env.VUE_APP_KEY,
        },
      })
      .then((response) => {
        // Check response
        // if (response.status != 200) {
        // 	console.log('the response from status was')
        // 	// console.error(response.statusText);
        // 	commit('SET_CONNECTION_STATUS', {
        // 		type: 'error',
        // 		message: "The session cannot be found"
        // 	})
        // 	return
        // }

        // Save all returned session and scenario data into store
        commit("SET_SESSION_AND_SCENARIO", response.data);

        // if there's only 1 result, everything is working
        commit("SET_CONNECTION_STATUS", {
          type: "ready",
          message: "Ready for the user to connect",
        });
      })
      .catch((error) => {
        // handle error
        // Check if multiple sessions were found [should not be possible]
        commit("SET_CONNECTION_STATUS", {
          type: "error",
          message:
            "There was a problem connecting to the session: " +
            error.response.data,
        });
      });
  },

  async fetchVideoURLs({ commit, getters }) {
    // Create a list of all the videos
    var videoList = [
      "The_Adv_About.mp4",
      "The_Adv_About.webm",
      "Oath.mp4",
      "Oath.webm",
      "Adv_Endings_Advocate.webm",
      "Adv_Endings_Advocate.mp4",
      "Adv_Endings_Adversary.webm",
      "Adv_Endings_Adversary.mp4",
    ];

    // Connect to cloud storage
    var storage = firebase.storage();

    // Loop through the list and create the downloadURLS
    for (let i = 0; i < videoList.length; i++) {
      storage
        .ref(videoList[i])
        .getDownloadURL()
        .then((url) => {
          commit("ADD_VIDEO_DOWNLOAD_URL", {
            filename: videoList[i],
            downloadURL: url,
          });
        });
    }
  },

  async signInAnonymously({ commit }, userObj) {
    //  connecting page is shown by default at the start
    commit("SET_CONNECTION_STATUS", {
      type: "connecting",
      message: "Signing in...",
    });

    return new Promise((resolve, reject) => {
      // listen for the success event
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          console.log("the user is signed in");
          commit("SET_USER_NAME", userObj.name);
          if (userObj.isAdmin) {
            commit("SET_ADMIN", true);
          }
          resolve(user);
        } else {
          commit("SET_CONNECTION_STATUS", {
            type: "error",
            message:
              "There was an error while logging in, please refresh the page and try again",
          });

          // User has signed out (not possible in this app)
          // console.error('there was an error signing the user in');
        }
      });

      // signin
      firebase
        .auth()
        .signInAnonymously()
        .catch(function(error) {
          reject("Error signing in... " + error.code + " – " + error.message);
        });
    });
  },

  connectToFirebase: ({ commit, dispatch, state, getters }) => {
    //  connecting page is shown by default at the start
    commit("SET_CONNECTION_STATUS", {
      type: "connecting",
      message: "Connecting to #" + state.session.id,
    });

    // load the session from firebase
    var sessionRef = firebase.database().ref("sessions/" + state.session.id);

    // Store the session reference for later use
    commit("SET_SESSION_REF", sessionRef);

    // Connect and sync to the list of users
    var usersListRef = firebase
      .database()
      .ref("sessions/" + state.session.id + "/usersList");

    // Add any new users into the userList automatically
    usersListRef.on("child_added", function(data) {
      commit("ADD_USER", {
        key: data.key,
        value: data.val(),
      });

      // Only the admin will automatically asign an operator
      if (
        state.user.isAdmin &&
        getters.usersList.length > 0 &&
        !state.controllerKey
      ) {
        dispatch("switchControllerTo", data.key);
      }
    });

    // Remove any users when they disconnect automatically
    usersListRef.on("child_removed", function(data) {
      commit("REMOVE_USER", data.key);

      // Only the admin will automatically assign a new operator
      if (state.user.isAdmin && data.key == state.controllerKey) {
        if (getters.usersList.length > 0) {
          // Assign the first user in the list as controller
          dispatch("switchControllerTo", getters.usersList[0].key);
        } else {
          commit("SET_CONTROLLER_KEY", null);

          // All users have logged out
          alert("All participants have left");
        }
      }
    });

    usersListRef.on("child_changed", function(childSnapshot, prevChildKey) {
      commit("USER_LIST_UPDATE", childSnapshot);

      // tell the operator that someone has disconnected
      if (state.user.isAdmin && !childSnapshot.val().connected) {
        alert(childSnapshot.val().name + " has left");
      }
    });

    if (!state.user.isAdmin) {
      // Create & push a new user reference with an auto-generated id
      // var userKey = usersListRef.push().key;
      var userKey = firebase.auth().currentUser.uid;
      var userRef = firebase
        .database()
        .ref("sessions/" + state.session.id + "/usersList/" + userKey);

      // store the current uses key in the user object
      commit("SET_USER_KEY", userKey);

      // Push a new user into the thing
      userRef.update({
        name: state.user.name,
        connected: true,
      });

      // Setup a disconnect event and remove this user from the list
      userRef.onDisconnect().update({
        connected: false,
      });
    }

    // Setup real-time listener for updates
    sessionRef.on("value", function(snapshot) {
      // Use the built it sync method to process the values
      dispatch("firebaseSync", snapshot.val());
    });

    // Tell the app it's connected
    commit("SET_CONNECTION_STATUS", {
      type: "success",
      message: "Connected",
    });
  },

  firebaseSync: ({ state, commit }, data) => {
    // Check data exists, otherwise stop immediately
    if (!data) {
      return;
    }

    // EVERYONE - update the controllerKey to sync with everyoe
    if (data.controllerKey) {
      commit("SET_CONTROLLER_KEY", data.controllerKey);

      // Check and decide if we're the controller or not
      commit(
        "SET_CONTROLLER",
        data.controllerKey == firebase.auth().currentUser.uid
      );

      if (data.controllerKey == firebase.auth().currentUser.uid) {
        // Add listener to clear user from the controllerKey
        firebase
          .database()
          .ref("sessions/" + state.session.id + "/controllerKey")
          .onDisconnect()
          .remove();
      } else {
        // Remove disconnect listener so we don't remove someone else as the controller
        firebase
          .database()
          .ref("sessions/" + state.session.id + "/controllerKey")
          .onDisconnect()
          .cancel();
      }
    }

    // EVERYONE - toggle the help
    if (data.requestingHelp && !state.requestingHelp) {
      // Help was just requested
      commit("SET_HELP", true);
      commit("SET_HELP_HINT", true);
    } else if (!data.requestingHelp && state.requestingHelp) {
      // Help was just cancelled/given
      commit("SET_HELP", false);
      commit("SET_HELP_HINT", false);
    }

    // Everyone - should listen to pageName changes (participant, controller, admin)
    if (data.pageName && state.pageName !== data.pageName) {
      commit("SET_PAGE", data.pageName);
    }

    /*// Everyone - should list to showControllerPage changes
		if (data.showControllerPage) {
			// commit('SET_HINT', 'controller')
			commit('SET_CONTROLLER_PAGE', true);
		} else if (state.showControllerPage) {
			commit('SET_CONTROLLER_PAGE', false);
		}*/

    // Only listen to countdown events if you are NOT the admin
    if (!state.user.isAdmin) {
      if (data.countdown) {
        commit("SET_COUNTDOWN", data.countdown);
      }
    }

    // Only listen to events if you are NOT the controller
    if (!state.user.isController) {
      if (data.side && state.side != data.side) {
        commit("SET_SIDE", data.side);
      }
      if (data.difficulty && state.difficulty != data.difficulty) {
        commit("SET_DIFFICULTY", data.difficulty);
      }
      if (data.visionText && state.visionText != data.visionText) {
        commit("SET_VISION", data.visionText);
      }
      if (data.motivationText && state.motivationText != data.motivationText) {
        commit("SET_MOTIVATION", data.motivationText);
      }
      if (data.impactText && state.impactText != data.impactText) {
        commit("SET_IMPACT", data.impactText);
      }
      if (data.methodText && state.methodText != data.methodText) {
        commit("SET_METHOD", data.methodText);
      }
      if (data.targetText && state.targetText != data.targetText) {
        commit("SET_TARGET", data.targetText);
      }
      if (data.objectiveText && state.objectiveText != data.objectiveText) {
        commit("SET_OBJECTIVE", data.objectiveText);
      }
      if (
        data.selectedArchetype &&
        state.selectedArchetype.title != data.selectedArchetype.title
      ) {
        commit("SET_ARCHETYPE", data.selectedArchetype);
      }

      if (
        data.archetypeOtherText &&
        state.archetypeOtherText != data.archetypeOtherText
      ) {
        commit("SET_ARCHETYPE_OTHER", data.archetypeOtherText);
      }

      if (
        data.selectedRole &&
        state.selectedRole.title != data.selectedRole.title
      ) {
        commit("SET_ROLE", data.selectedRole);
      }

      if (data.roleOtherText && state.roleOtherText != data.roleOtherText) {
        commit("SET_ROLE_OTHER", data.roleOtherText);
      }

      if (data.roleActiveTab && state.roleActiveTab != data.roleActiveTab) {
        commit("SET_ROLE_TAB", data.roleActiveTab);
      }
      if (
        data.strategyActiveTab &&
        state.strategyActiveTab != data.strategyActiveTab
      ) {
        commit("SET_STRATEGY_TAB", data.strategyActiveTab);
      }
      if (
        data.confirmActiveTab &&
        state.confirmActiveTab != data.confirmActiveTab
      ) {
        commit("SET_CONFIRM_TAB", data.confirmActiveTab);
      }
      if (
        data.feedbackActiveTab &&
        state.feedbackActiveTab != data.feedbackActiveTab
      ) {
        commit("SET_FEEDBACK_TAB", data.feedbackActiveTab);
      }

      // Maybe we process this differently? like an array
      if (data.feedback) {
        commit("SET_ALL_FEEDBACK", data.feedback);
      }
    }
  },

  requestHelp: ({ state }) => {
    state.sessionRef.update({
      requestingHelp: true,
    });
  },

  switchControllerTo: ({ state }, userKey) => {
    state.sessionRef.update({
      controllerKey: userKey,
    });
  },

  startCountdownInSecs: ({ state, commit, dispatch }, secs) => {
    // Make sure it's a number
    if (!secs) throw new Error("no time specified");

    // Set the target tiem that we should calculate the difference between
    commit("SET_COUNTDOWN_TARGET", new Date().getTime() + secs * 1000);

    // Store the interval so we can clear it later
    commit(
      "SET_COUNTDOWN_TIMER",
      setInterval(() => {
        // Get todays date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        commit("SET_COUNTDOWN", state.countdownTarget - now);
      }, 1000)
    );
  },

  stopCountdown: ({ state, commit }) => {
    // stop the timer
    clearInterval(state.countdownTimer);

    // clear the saved interval
    commit("SET_COUNTDOWN_TIMER", null);
    commit("SET_COUNTDOWN_TARGET", null);
    commit("SET_COUNTDOWN", null);
  },

  goto: ({ commit, state }, page) => {
    commit("SET_PAGE", page);
  },

  gotoNextPage: ({ state, dispatch }, hint) => {
    // validate
    let newPageIndex =
      pagesJson.findIndex((p) => p.name === state.pageName) + 1;

    if (newPageIndex >= pagesJson.length) {
      // No more pages
      console.log("no more pages");
    } else {
      dispatch("goto", pagesJson[newPageIndex].name);
    }
  },

  showVolumeControls({ commit }) {
    console.log("showVolumeControls");

    commit("SET_VOLUME_HINT", true);
  },

  hideVolumeControls({ commit }) {
    commit("SET_VOLUME_HINT", false);
  },

  showHint: ({ commit, state }, hint) => {
    commit("SET_HINT", hint);
  },

  showTactic: ({ commit, state }, tactic) => {
    // remove the active flag from any other tactics
    commit("UNSET_ACTIVE_TACTIC");
    // set the tactic at 'index' as the active one
    commit("SET_ACTIVE_TACTIC", tactic);
  },

  setSide: ({ state, commit }, value) => {
    if (state.user.isController) {
      commit("SET_SIDE", value);
    }
  },

  setDifficulty: ({ state, commit }, value) => {
    if (state.user.isController) {
      commit("SET_DIFFICULTY", value);
    }
  },

  setArchetype: ({ state, commit }, value) => {
    if (state.user.isController) {
      commit("SET_ARCHETYPE", value);
    }
  },

  setRole: ({ state, commit }, value) => {
    if (state.user.isController) {
      commit("SET_ROLE", value);
    }
  },

  setRoleTab: ({ state, commit }, value) => {
    if (state.user.isController) {
      commit("SET_ROLE_TAB", value);
    }
  },

  setStrategyTab: ({ state, commit }, value) => {
    if (state.user.isController) {
      commit("SET_STRATEGY_TAB", value);
    }
  },

  setFeedback: ({ state, commit }, value) => {
    if (state.user.isController) {
      commit("SET_FEEDBACK", value);
    }
  },

  setFeedbackTab: ({ state, commit }, value) => {
    if (state.user.isController) {
      commit("SET_FEEDBACK_TAB", value);
    }
  },

  toggleControllerPage: ({ state, commit }) => {
    commit("SET_CONTROLLER_PAGE", !state.showControllerPage);
  },
};
